// Skeleton loading placeholder component.
// Displays shimmer-animated rows to indicate content is being loaded.

import { PolymerElement, html } from "@polymer/polymer/polymer-element.js";

import "./LoadingDisplay.style";

class LoadingDisplay extends PolymerElement {
  static get template() {
    return html`
      <style include="loading-display-style"></style>
      <div class="ai-loading" aria-busy="true" aria-live="polite">
        <div class="row w60"></div>
        <div class="row w85"></div>
        <div class="row w40"></div>
      </div>
    `;
  }
}

customElements.define("loading-display", LoadingDisplay);
